import { useState } from "react";
import { useDeleteNotification } from '../../../apis/notifications/delete-notification';
import { useGetAllNotifications } from '../../../apis/notifications/get-all-notifications';

const useAnnouncements = () => {
    const [app, setApp] = useState("user");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedNotificationId, setSelectedNotificationId] = useState("");
    const [isSendNotificationModalOpen, setIsSendNotificationModalOpen] = useState(false);

    const { data, isFetching: isLoading, refetch } = useGetAllNotifications({
        userType: app,
        limit: 10,
        page: currentPage,
    });

    const { mutateAsync: deleteNotification, isPending: isDeletingNotification } = useDeleteNotification();

    const handleDeleteNotification = async () => {
        await deleteNotification(selectedNotificationId);
        if ((data?.docs?.length ?? 0) <= 1 && currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
        setSelectedNotificationId("");
        refetch();
    };

    const handleAppChange = (value: string) => {
        setApp(value);
        setCurrentPage(1);
    };

    return {
        notifications: data?.docs ?? [],
        totalPages: data?.totalPages ?? 0,
        isLoading,
        isDeletingNotification,
        isSendNotificationModalOpen,
        setIsSendNotificationModalOpen,
        app,
        currentPage,
        setCurrentPage,
        selectedNotificationId,
        setSelectedNotificationId,
        handleDeleteNotification,
        handleAppChange,
        refetch,
    };
};

export default useAnnouncements;